export default __webpack_public_path__ + "static/img-2-0dfc510deda13da943fd208f4ab051b6.png";